'use strict';

exports.Configuration = function () {
    var config = void 0;

    return {
        setConfig: function setConfig(reduxConfig) {
            config = reduxConfig;
        },
        getConfig: function getConfig() {
            if (!config) {
                config = require('./config/devConfig.json');
            }
            return config;
        }
    };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/config.js
// module id = 735
// module chunks = 0